var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneKoalafi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 20.8333C26.25 20.8333 24.25 20.5 22.3833 19.8833C22.2167 19.8333 22.0333 19.8 21.8667 19.8C21.4333 19.8 21.0167 19.9667 20.6833 20.2833L17.0167 23.95C12.2898 21.5453 8.44519 17.7065 6.03333 12.9833L9.7 9.3C10.1667 8.85 10.3 8.2 10.1167 7.61667C9.48442 5.69676 9.16369 3.688 9.16667 1.66667C9.16667 0.75 8.41667 0 7.5 0H1.66667C0.75 0 0 0.75 0 1.66667C0 17.3167 12.6833 30 28.3333 30C29.25 30 30 29.25 30 28.3333V22.5C30 21.5833 29.25 20.8333 28.3333 20.8333ZM3.38333 3.33333H5.88333C6 4.8 6.25 6.25 6.65 7.65L4.65 9.66667C3.96667 7.65 3.53333 5.53333 3.38333 3.33333ZM26.6667 26.6167C24.4667 26.4667 22.3333 26.0333 20.3333 25.35L22.3333 23.35C23.75 23.75 25.2 24 26.6667 24.1V26.6167ZM15 0V16.6667L20 11.6667H30V0H15ZM26.6667 8.33333H18.3333V3.33333H26.6667V8.33333Z",
    fill: "#0D4066"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneKoalafi);
export default __webpack_public_path__ + "static/media/phone-koalafi.a462ea061707ed295ce94e10cfa359f1.svg";
export { ForwardRef as ReactComponent };